import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import axios from 'services/axios'
import { selectCurrentZone } from 'store/global'
import { CurrentZone } from 'utils/types'

export interface IFilterOptions {
  activitiesFrom: string[]
  activityTypes: string[]
  directions: string[]
  tokenTypes: string[]
}

const useFilterOptions = () => {
  const { entityId } = useParams<{ entityId: string }>()
  const currentZone: CurrentZone = useSelector(selectCurrentZone)
  const [options, setOptions] = useState<IFilterOptions | null>(null)

  useEffect(() => {
    axios
      .get(`crypto/filter-options/${entityId}`, {
        params: {
          zone: currentZone.cryptoActivityIndices,
          entityZone: currentZone.cryptoIndices,
        },
      })
      .then(res => setOptions(res.data))
      .catch(err => console.error(err))
  }, [entityId, currentZone.cryptoActivityIndices, currentZone.cryptoIndices])

  return { options }
}

export default useFilterOptions
